import React from 'react';

import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { FormControl, TextField, FormHelperText } from '@material-ui/core';

export interface TextInputUiOptions {
  maxLength?: number;
  rows?: number;
  unique?: {
    kind: string;
    type?: string;
  };
}

export const TextInput = (
  props: FieldExtensionComponentProps<string, TextInputUiOptions>,
) => {
  const {
    onChange,
    schema: { title = '', description = '', type = 'string' },
    required,
    rawErrors,
    formData,
    idSchema,
    uiSchema,
    disabled,
  } = props;

  const widgetType = uiSchema?.['ui:widget'];
  const uiOptions = uiSchema?.['ui:options'] || {};

  const isTextarea = widgetType === 'textarea';
  const rows = isTextarea ? uiOptions.rows || 5 : undefined;
  const maxLength = !isTextarea ? uiOptions.maxLength : undefined;

  return (
    <FormControl fullWidth error={rawErrors?.length > 0 && !formData}>
      <TextField
        size="small"
        required={required}
        id={idSchema?.$id}
        label={title || ''}
        variant="outlined"
        type={type === 'number' ? 'number' : 'text'}
        value={formData || ''}
        onChange={e => onChange(e.target.value)}
        multiline={isTextarea}
        minRows={rows}
        disabled={Boolean(disabled)}
        fullWidth
        inputProps={{
          maxLength: maxLength,
        }}
      />
      {description && <FormHelperText>{description}</FormHelperText>}
    </FormControl>
  );
};
